import { PlanLocationGroup } from "../../models/plan-location-group";

export interface PlanRequest {
    id?: string;
    name?: string;
    description?: string;
    day:number;
    planContainerId?: string;
    organizationUnitId?: string;
    orgUnitId?:string
    planDays: number[];
    planLocationGroups:PlanLocationGroup[];
}
